import TextShow from './TextShow';

export default TextShow;


// WEBPACK FOOTER //
// ./src/components/TextShow/index.js